import { gql } from '@apollo/client';
import { insuranceBaseData } from 'services/query/insurances';

export const CREATE_INSURANCE = gql`
  mutation createInsurance($data: InsuranceCreateInput!) {
    createInsurance(data: $data) {
      id
    }
  }
`;

export const UPDATE_INSURANCE = gql`
  mutation updateInsurance($id: ID!, $data: InsuranceUpdateInput!) {
    updateInsurance(id: $id, data: $data) {
      ${insuranceBaseData}
      dispatchEmail
    }
  }
`;

export const DELETE_INSURANCE = gql`
  mutation deleteInsurance($id: ID!) {
    deleteInsurance(id: $id)
  }
`;
